import {
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";

export const SERVER_URL = import.meta.env.VITE_SERVER;

console.log("SERVER_URL:", SERVER_URL);

// Function to get token from localStorage
export const getToken = () => {
  try {
    return localStorage.getItem("token");
  } catch (error) {
    console.error("Error getting token:", error);
    return null;
  }
};

// Basic baseQuery
const rawBaseQuery = fetchBaseQuery({
  baseUrl: SERVER_URL,
  prepareHeaders: (headers) => {
    const token = getToken();

    if (token) {
      console.log(token);
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

// Advanced baseQuery with Re-auth (retry after 401)
const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    console.warn("Unauthorized: Resetting schoolid...");
    try {
      localStorage.removeItem("schoolid");
    } catch (error) {
      console.error("Error removing schoolid:", error);
    }

    result = await rawBaseQuery(args, api, extraOptions);
  }

  return result;
};

// Define the API slice
export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  reducerPath: "api",
  tagTypes: ["User"],
  endpoints: (builder) => ({
    userDetail: builder.query({
      query: () => ({
        url: "/",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["User"],
    }),
  }),
});

// Export hooks for usage in components
export const { useUserDetailQuery } = apiSlice;
